import React, {forwardRef, useImperativeHandle} from 'react'
import PropTypes from 'prop-types'

import {Section}   from "../../02-Molecules/Section/Section"
import {FormField} from "../../02-Molecules/FormField/FormField"

/**
 * Primary UI component for user interaction
 */
export const SectionCustomFields = forwardRef(({ collapsed, heading, headingLarge, fields, onInputChange, required, sectionId, recap, textAfter, textBefore, validationHash, values,  ...props }, ref) => {
  const isValid = () => {
    return fields.reduce((isValid, field) => values[field.name] === '' ? false : isValid, true)
  }

  useImperativeHandle(ref, () => ({
    isValid: ()  => isValid(),
  }))

  return (
    <Section collapsed={collapsed} heading={heading} headingLarge={headingLarge}
    sectionId={sectionId} textAfter={textAfter} textBefore={textBefore}>
      <div>
        {fields.map((field, key) => {
          return (
            <div key={key}>
              <FormField
                onInputChange={onInputChange}
                value={values[field.name]}
                validationHash={validationHash}
                {...field} />
            </div>
          )
        })}
      </div>
    </Section>
  )
})

SectionCustomFields.propTypes = {
  collapsed    : PropTypes.bool,
  required     : PropTypes.bool,
  heading      : PropTypes.string,
  headingLarge : PropTypes.bool,
  sectionId    : PropTypes.string,
  textAfter    : PropTypes.string,
  textBefore   : PropTypes.string,
  onInputChange: PropTypes.func,
  values: PropTypes.shape({
    payment_reason      : PropTypes.string,
    payment_reason_other: PropTypes.string,
  }),
  fields        : PropTypes.arrayOf(PropTypes.object),
  validationHash: PropTypes.string,
}

SectionCustomFields.defaultProps = {
  collapsed: false,
  recap    : false,
  required : false
}
